import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ThemeState } from '../../interfaces/ui/ui.interface';

const featuredSelector = createFeatureSelector<Readonly<ThemeState>>('theme');

export const selectTheme = createSelector(
  featuredSelector,
  (state) => state.value
);
